import { GMFleetLink } from "../../constants/links"
import React from "react"
import imgFleet from "../../images/quesgasolinamovilfleet.png"
import styles from "./fleet-about.module.css"

export default function FleetAbout() {
  return (
    <div className="row">
      <div className="col-12">
        <img
          src={imgFleet}
          className={styles.fleetImg}
          alt="¿Que es Gasolina Móvil Fleet?"
        />
        <p className={`${styles.fleetText}`}>
          Gasolina Móvil Fleet es la solución completa para manejar el
          combustible de tu flota — segura, multimarca y con control total en
          tiempo real
        </p>
        <a
          href={GMFleetLink}
          target="_blank"
          rel="noreferrer"
          className={styles.fleetLink}
        >
          Conoce más
        </a>
      </div>
    </div>
  )
}
